import {
    PageContainer,
    PageContainerProps,
    PageHeader,
    PageHeaderToolbar,
} from '@toolpad/core';
import React from 'react';
import { Box } from '@mui/system';

export function RootContainer(props: PageContainerProps) {
    const { children, ...rest } = props;

    // const CustomPageToolbarComponent = React.useCallback(
    //     () => (
    //         <CustomPageHeader>
    //             <Box gap={2} flexDirection="row" display="flex">
    //                 <InputComponent />
    //                 <Button
    //                     variant="contained"
    //                     color="primary"
    //                     size="small"
    //                     onClick={handleAddClick}
    //                 >
    //                     Add User
    //                 </Button>
    //             </Box>
    //         </CustomPageHeader>
    //     ),
    //     [InputComponent, handleAddClick]
    // );

    return <PageContainer {...rest}>{children}</PageContainer>;
}

interface CustomPageToolbarProps {
    children: React.ReactNode;
}

export function CustomToolbar({ children }: CustomPageToolbarProps) {
    return (
        <PageHeaderToolbar>
            <Box gap={2} flexDirection="row" display="flex">
                {children}
            </Box>
        </PageHeaderToolbar>
    );
}

export function CustomPageHeader({ children }: CustomPageToolbarProps) {
    return (
        <PageHeader
            slots={{
                toolbar: () => <CustomToolbar>{children}</CustomToolbar>,
            }}
        />
    );
}
